import { apiService } from "./ApiService";
import { AuthService } from "./AuthService";
import { InvoiceService } from "./InvoiceService";
import { ClientService } from "./ClientService";
import { OnboardingService } from "./OnboardingService";
import { WorkOrdersService } from "./WorkOrdersService";
import DisputeService from "./DisputeService";
import SupportTicketService from "./SupportTicketService";
import { AboutAgencyService } from "./AboutAgencyService";
import { FeedbackService } from "./FeedbackService";
import { BillingService } from "./BillingService";
import { IntegrationsService } from "./IntegrationsService";
import { MeetingsService } from "./MeetingsService";

export const authService = new AuthService(apiService);
export const invoiceService = new InvoiceService(apiService);
export const clientService = new ClientService(apiService);
export const onboardingService = new OnboardingService(apiService);
export const workOrdersService = new WorkOrdersService(apiService);
export const disputeService = new DisputeService(apiService);
export const supportTicketService = new SupportTicketService(apiService);
export const aboutAgencyService = new AboutAgencyService(apiService);
export const feedbackService = new FeedbackService(apiService);
export const billingService = new BillingService(apiService);
export const integrationsService = new IntegrationsService(apiService);
export const meetingsService = new MeetingsService(apiService);

export { apiService };

export { AuthService } from "./AuthService";
export { InvoiceService } from "./InvoiceService";
export { ClientService } from "./ClientService";
export { OnboardingService } from "./OnboardingService";
export { WorkOrdersService } from "./WorkOrdersService";
export { default as DisputeService } from "./DisputeService";
export { default as SupportTicketService } from "./SupportTicketService";
export { AboutAgencyService } from "./AboutAgencyService";
export { IntegrationsService } from "./IntegrationsService";
export { ContentService } from "./ContentService";
export { MeetingsService } from "./MeetingsService";
